//@ts-check
import { useEffect } from "react"

/**
 * You cannot provide async function to useEffect like this:
 * useEffect(async(){
 * })
 * It gives the following error:
<error>
An effect function must not return anything besides a function, which is used for clean-up.

It looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:
</error>

To fix is use:
useAsyncEffect(yourFunc)

@param asyncFn {(abortSignal:AbortSignal)=>void}
@param deps {Array}
*/
export default function useAsyncEffect(asyncFn,deps=[]) {
  var abortController=new AbortController()
  useEffect(() => {
    asyncFn(abortController.signal)
    return ()=>{
      abortController.abort()
    }
  }, deps)
}
